import http from './http'

// 可提取的金币数量
export const apiGoldNumber = () => http.post('/web/invite/extractable/gold')

// 提取金币
export const apiWithdrawalGold = () => http.post('/web/invite/gold/extract')

// 邀请记录
export const apiGetInvitedRecord = (scroll) => http.post('/web/invite/my',scroll)

// 金币明细
export const apiGetGoldRecord = (scroll) => http.post('/web/invite/gold/record', scroll)

// 获取分享链接
export const apiGetShareLink = () => http.post('/web/share/link')

// 记录分享链接
export const apiGetShareLinkCode = (code,coupon) => http.post('/withoutsign/share/record/add', { code,coupon })



// WEBPACK FOOTER //
// src/helper/gold.js